import React from "react";
import { WhmFlexDataGrid } from "@securitize/reactjs-whm";
import { translationKeys } from "../../../../contexts/I18nContext";
import { useTranslation } from "../../../../hooks/useTranslation";

type LocaleText = React.ComponentProps<typeof WhmFlexDataGrid>["localeText"];

export function useLocaleText(): LocaleText {
  const { getTranslation: t } = useTranslation();

  return {
    MuiTablePagination: {
      labelRowsPerPage: t(
        translationKeys.DOCUMENT_DATAGRID_PAGINATOR_LABEL_ROWS_PER_PAGE,
      ),
      labelDisplayedRows: ({ from, to, count }) =>
        `${from} - ${to} ${t(translationKeys.DOCUMENT_DATAGRID_PAGINATOR_LABEL_DISPLAYED_ROWS)} ${
          count === -1
            ? `${t(translationKeys.DOCUMENT_DATAGRID_PAGINATOR_LABEL_DISPLAYED_ROWS_MORE)} ${to}`
            : count
        }`,
    },
  };
}
